"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = (props.theme ?? "system") as ToasterProps["theme"];

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      offset="20px"
      gap={12}
      visibleToasts={5}
      duration={4000}
      toastOptions={{
        style: {
          background: 'white',
          border: 'none',
          borderRadius: '0',
          padding: '16px 20px',
          fontSize: '15px',
          fontWeight: '600',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
          minWidth: '380px',
          maxWidth: '480px',
          position: 'relative',
          overflow: 'hidden',
        },
        classNames: {
          toast: 'toast-custom',
          title: 'toast-title',
          description: 'toast-description',
          error: 'toast-error',
          success: 'toast-success',
          warning: 'toast-warning',
          info: 'toast-info',
        },
        className: 'toast-animate',
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
